import { useState, useEffect } from "react";
import { useApp } from "@/context/AppContext";
import { getProperties } from "@/lib/api";
import { PropertyCard } from "@/components/PropertyCard";

export const GuestFavorites = () => {
  const { t } = useApp();
  const [items, setItems] = useState([]);

  useEffect(() => {
    getProperties({ guest_favorite: true, sort: "rating", limit: 6 })
      .then(setItems)
      .catch(() => {});
  }, []);

  return (
    <section className="bg-sand py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mb-12 max-w-2xl">
          <p className="overline text-terracotta">{t("sections.fav_over")}</p>
          <h2 className="mt-3 font-serif text-4xl font-medium text-petrol lg:text-5xl">{t("sections.fav_title")}</h2>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((p, i) => (
            <PropertyCard key={p.slug} p={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
